/**
 * Component Registry for Repli Sandbox Avenew Theme
 * 
 * Extends the base american-landmark-arte theme registry with Repli Sandbox Avenew specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-american-landmark-arte/registry';

/**
 * Repli Sandbox Avenew specific component overrides.
 * These components have been customized for the Repli Sandbox Avenew brand.
 * 
 * Example:
 * import { Footer } from './components/Footer';
 * 
 * const replisandboxavenewOverrides: Partial<ComponentRegistry> = {
 *   Footer,
 * };
 */
const replisandboxavenewOverrides: Partial<ComponentRegistry> = {
  // Add component overrides here
};

/**
 * Final merged registry for Repli Sandbox Avenew properties.
 * Inherits all components from the american-landmark-arte theme, with Repli Sandbox Avenew overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...replisandboxavenewOverrides,
};

export default registry;
